webpackJsonp([18],{

/***/ 225:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);

var DESIGNER_SHOP_ENDPOINT = '/content/myfav/designers/mobile';
var SELECTORS = {
  toggleBrandHeart: '.js-favorite-brand',
  submitHeartedBrands: '#submit-hearted-brands',
  toggleProductHeart: '.js-fav-item',
  // Used on trending product scroll for fav onboarding - step #3
  submitHeartedProducts: '#submit-hearted-products'
};
function init() {
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(SELECTORS.toggleBrandHeart).click(toggleBrandHeart);
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(SELECTORS.submitHeartedBrands).click(submitHeartedBrands);
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(SELECTORS.toggleProductHeart).click(toggleProductHeart);
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(SELECTORS.submitHeartedProducts).click(submitHeartedProducts);
}
var brands = [];
var products = [];
function toggleBrandHeart() {
  var activeContainerClass = 'favorite-button__container--active-clear';
  var brand = encodeURIComponent(__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).data('value'));
  if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).hasClass(activeContainerClass)) {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).removeClass(activeContainerClass);
    brands.splice(brands.indexOf(brand), 1);
  } else {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).addClass(activeContainerClass);
    brands.push(brand);
  }
}
function submitHeartedBrands() {
  var isGuest = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#myFavLimitPopup').data('isGuest');
  if (isGuest) {
    var favBrands = brands.map(function (brand) {
      return "favbrand=" + brand;
    }).join("&");
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#guestLimitPop, #fav-create-link').attr('href', "/r/mobile/LoginPage.jsp?" + favBrands + "&ref=" + encodeURIComponent(DESIGNER_SHOP_ENDPOINT + "?d=" + rcProps.department));
    __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal({
      triggerOpen: true,
      open: "guestLimitPop"
    });
    return;
  }
  var bcodesParam = brands.map(function (brand) {
    return "bcodes=" + brand;
  }).join("&");
  var data = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.param({
    action_T: 'add',
    mensBrand: rcProps.department === "Mens"
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({
    type: 'POST',
    url: '/r/ajaxHeartProduct.jsp?' + bcodesParam,
    data: data,
    success: function success() {
      var endpoint = DESIGNER_SHOP_ENDPOINT + "?d=" + rcProps.department;
      if (typeof gaUpdateHeartBrand === 'function') {
        var brandsDecoded = brands.map(function (brand) {
          return decodeURIComponent(brand);
        });
        gaUpdateHeartBrand('add', brandsDecoded.join(","), function () {
          location.href = endpoint;
        });
      } else {
        location.href = endpoint;
      }
    }
  });
}
function toggleProductHeart() {
  var activeButtonClass = window.rcProps && window.rcProps.favoriteActiveClass || "favorite-button--active";
  var product = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).data('value');
  if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).hasClass(activeButtonClass)) {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).removeClass(activeButtonClass);
    products.splice(products.indexOf(product), 1);
  } else {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).addClass(activeButtonClass);
    products.push(product);
  }
}
function submitHeartedProducts() {
  var $this = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this);
  var isGuest = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#myFavLimitPopup').data('isGuest');
  if (isGuest) {
    var productCodeParams = "";
    if (products.length > 0) {
      for (var i = 0; i < products.length; i++) {
        if (i == products.length - 1) productCodeParams += "favcode=" + products[i];else productCodeParams += "favcode=" + products[i] + "&";
      }
    }
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#guestLimitPop, #fav-create-link').attr('href', "/r/mobile/LoginPage.jsp?" + productCodeParams + "&ref=" + encodeURIComponent(window.location.pathname + window.location.search));
    __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal({
      triggerOpen: true,
      open: "guestLimitPop"
    });
    return;
  }
  var pcodesParam = "";
  var pCodes = "";
  for (var i = 0; i < products.length; i++) {
    var b = products[i];
    if (i == 0) {
      pcodesParam += "pcodes=" + b;
      pCodes += b;
    } else {
      pcodesParam += "&pcodes=" + b;
      pCodes += "," + b;
    }
  }
  var data = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.param({
    action_T: 'add'
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({
    type: 'POST',
    url: '/r/ajaxHeartProduct.jsp?' + pcodesParam,
    data: data,
    success: function success() {
      if (typeof iPinYouHeartItem === 'function') {
        iPinYouHeartItem(pCodes);
      }
      if (typeof taboolaWishListAction === 'function') {
        taboolaWishListAction('add', pCodes);
      }
      location.href = '/r/mobile/mr_favorites.jsp?d=' + $this.data("department");
    }
  });
}
__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).ready(function () {
  init();
});

/***/ })

},[225]);


// WEBPACK FOOTER //
// dist/myfavonboard.js